import { Customer } from "common";
import React from "react";
import { YStack, Text, Card, Separator } from "tamagui";

import { joinTruthy } from "../../../utils";

interface CustomerInfoCardProps {
  customer: Customer;
}

export const CustomerInfoCard: React.FC<CustomerInfoCardProps> = ({
  customer,
}) => (
  <Card elevate bordered padding="$5" borderRadius="$4" space>
    <YStack space="$3">
      <Text fontSize="$7" fontWeight="700">
        {customer.name || "Unnamed Customer"}
      </Text>

      {customer.companyName && (
        <Text color="$gray10" fontSize="$4" fontWeight="600">
          {customer.companyName}
        </Text>
      )}

      <Separator borderColor="$gray5" />

      <Field label="Email" value={customer.email} />
      <Field label="Phone" value={customer.phone} />
      <Field
        label="Address"
        value={
          joinTruthy(
            [
              customer.address,
              customer.city,
              joinTruthy([customer.state, customer.zipCode], " "),
              customer.country,
            ],
            ",",
          ) || "Unknown"
        }
      />
      {customer.createdAt && (
        <Field
          label="Created At"
          value={new Date(customer.createdAt).toLocaleDateString()}
        />
      )}
    </YStack>
  </Card>
);

const Field = ({ label, value }: { label: string; value?: string }) => {
  if (!value) return null;
  return (
    <YStack space="$1">
      <Text fontSize="$2" color="$gray10" fontWeight="600">
        {label}
      </Text>
      <Text fontSize="$4">{value}</Text>
    </YStack>
  );
};
